module.exports = __webpack_public_path__ + "img/arrow.735a3039.svg";